import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Counselors from "./pages/Counselors";
import Staff from "./pages/Staff";
import Locations from "./pages/Locations";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import CounselorsUtah from "./pages/CounselorsUtah";
import CounselorsOregon from "./pages/CounselorsOregon";
import Therapy from "./pages/Therapy";
import ModalityACT from "./pages/Modality/ModalityACT";
import TherapyADHD from "./pages/Therapy/TherapyADHD";
import TherapyAnxiety from "./pages/Therapy/TherapyAnxiety";
import ModalityCBT from "./pages/Modality/ModalityCBT";
import ModalityDBT from "./pages/Modality/ModalityDBT";
import TherapyDepression from "./pages/Therapy/TherapyDepression";
import ModalityEMDR from "./pages/Modality/ModalityEMDR";
import ModalityIFS from "./pages/Modality/ModalityIFS";
import TherapyPTSD from "./pages/Therapy/TherapyPTSD";
import TherapyTrauma from "./pages/Therapy/TherapyTrauma";
import TherapyGrief from "./pages/Therapy/TherapyGrief";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/utah" element = {<CounselorsUtah />} />
        <Route path="/oregon" element={<CounselorsOregon />} />
        <Route path="/locations" element = {<Locations />} />
        <Route path="/therapy" element = {<Therapy />} />
        <Route path="/ACT-modality" element = {<ModalityACT />} />
        <Route path="/ADHD-therapy" element = {<TherapyADHD />} />
        <Route path="/anxiety-therapy" element = {<TherapyAnxiety />} />
        <Route path="/CBT-modality" element = {<ModalityCBT />} />
        <Route path="/DBT-modality" element = {<ModalityDBT />} />
        <Route path="/depression-therapy" element = {<TherapyDepression />} />
        <Route path="/EMDR-modality" element = {<ModalityEMDR />} />
        <Route path="/IFS-modality" element = {<ModalityIFS />} />
        <Route path="/PTSD-therapy" element = {<TherapyPTSD />} />
        <Route path="/trauma-therapy" element = {<TherapyTrauma />} />
        <Route path="/grief-therapy" element = {<TherapyGrief />} />
        <Route path="/counselors" element={<Counselors />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;